import styled from 'styled-components';
import { Input } from 'antd';

export const CompletionTabContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 12px;
`;

export const ItemContainer = styled.div`
  display: flex;
  flex: 1 1 auto;
  width: 100%;
  max-width: 372px;
`;

export const FilterContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const SearchContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const StyledInput = styled(Input)`
  border-radius: 6px;
  font-size: 14px;
`;
